var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableAnimations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_5051)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1371_5051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1371_5051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20313 17.2656H1.45313C1.2625 17.2656 1.07969 17.1899 0.944888 17.0551C0.810098 16.9203 0.734375 16.7375 0.734375 16.5468V1.45313C0.734375 1.2625 0.810098 1.07969 0.944888 0.944888C1.07969 0.810098 1.2625 0.734375 1.45313 0.734375H11.0075C11.1981 0.734416 11.3808 0.810166 11.5156 0.944971L14.1801 3.60938C14.3148 3.74414 14.3906 3.92693 14.3906 4.11753V6.48437",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43631 8.20384L5.86337 6.28042C5.77975 6.23381 5.6854 6.20987 5.58968 6.21097C5.49395 6.21207 5.40018 6.23818 5.31766 6.28671C5.23513 6.33523 5.16673 6.40449 5.11923 6.4876C5.07173 6.57073 5.04679 6.66481 5.04688 6.76055V10.8833C5.04679 10.9791 5.07173 11.0731 5.11923 11.1562C5.16673 11.2394 5.23513 11.3086 5.31766 11.3571C5.40018 11.4057 5.49395 11.4318 5.58968 11.4329C5.6854 11.434 5.77975 11.41 5.86337 11.3634L7.42666 10.4017",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6416 12.9551C8.6416 13.5214 8.75313 14.0822 8.96988 14.6054C9.18655 15.1286 9.50425 15.604 9.90468 16.0044C10.3052 16.4049 10.7805 16.7226 11.3038 16.9393C11.827 17.1561 12.3878 17.2676 12.9541 17.2676C13.5204 17.2676 14.0812 17.1561 14.6044 16.9393C15.1276 16.7226 15.603 16.4049 16.0035 16.0044C16.404 15.604 16.7216 15.1286 16.9383 14.6054C17.1551 14.0822 17.2666 13.5214 17.2666 12.9551C17.2666 12.3888 17.1551 11.828 16.9383 11.3048C16.7216 10.7815 16.404 10.3062 16.0035 9.90565C15.603 9.50523 15.1276 9.18753 14.6044 8.97085C14.0812 8.7541 13.5204 8.64258 12.9541 8.64258C12.3878 8.64258 11.827 8.7541 11.3038 8.97085C10.7805 9.18753 10.3052 9.50523 9.90468 9.90565C9.50425 10.3062 9.18655 10.7815 8.96988 11.3048C8.75313 11.828 8.6416 12.3888 8.6416 12.9551Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9043 16.0028L16.0028 9.9043",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_5051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableAnimations);
export default __webpack_public_path__ + "static/media/disable_animations.ea70db4a615e911d7ecbb3a1f93cff70.svg";
export { ForwardRef as ReactComponent };